import { defineComponent, defineAsyncComponent } from "vue";
import type { AsyncComponentLoader, Component } from "vue";

interface ComponentData {
	name: string;
	component: Component | AsyncComponentLoader;
	defaultValue: any;
}

class CustomFormRegistry {
	private _fieldTypeComponentMappings = new Map<string, ComponentData>();

	register(serverType: string, componentName: string, component: Component, defaultValue: any = null) {
		this._fieldTypeComponentMappings.set(serverType, { name: componentName, component, defaultValue: defaultValue });
	}

	registerAsync(serverType: string, componentName: string, componentLoader: AsyncComponentLoader, defaultValue: any = null) {
		this._fieldTypeComponentMappings.set(serverType, { name: componentName, component: defineAsyncComponent(componentLoader), defaultValue: defaultValue });
	}

	getComponentName(serverType: string) {
		return this._fieldTypeComponentMappings.get(serverType)?.name;
	}

	getComponent(serverType: string) {
		return this._fieldTypeComponentMappings.get(serverType);
	}

	getComponents() {
		let components: { [name: string]: Component | AsyncComponentLoader } = {};
		for (let { name, component } of this._fieldTypeComponentMappings.values()) {
			components[name] = component;
		}
		return components;
	}
}

export const customFormRegistry = new CustomFormRegistry();
